/*
 * @Date: 2019-08-20 18:24:17
 * @LastEditors: x
 * @LastEditTime: 2019-08-22 10:36:54
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

Vue.config.productionTip = false

//引入css,js
import 'assets/js/rem_min'
import 'assets/scss/index.scss'

//注册Toast全局组件
import Toast from 'components/base/toast'
Vue.use(Toast)

import util from 'libs/util'
Vue.prototype.$util = util

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js